module.exports = __webpack_public_path__ + "static/media/booster_3_right.d9329f5c.png";